import {
	showAlert,
	fetchRegionsSuccess,
	fetchAllLangSuccess,
	setPageTitle,
	setPageHeaderLogo,
	resetCommonModule,
	changeSalaryStructureSorting
} from "../mutation-types";
import {
	SHOW_ALERT,
	FETCH_REGIONS,
	FETCH_ALL_LANGUAGES,
	UPDATE_PAGE_TITLE,
	SET_PAGE_HEADER_LOGO,
	RESET_COMMON_MODULE,
	CHANGE_SALARY_STRUCTURE_SORTING,
	GET_RETAILER_PROFILE,
	UPDATE_RETAILER_PROFILE,
	GET_DSTR_SIGNATURE,
	UPLOAD_DSTR_SIGNATURE
} from "../action-types";

import ApiService from "../api-service";
import { DEFAULT_ERROR_MESSAGE } from "../config";
import { BASE_URL } from "../../../config";
import { PANEL_DATA } from "@/utils";
const state = {
	APP_VERSION: "0.0.1",
	alert: {
		show: false,
		text: "",
		timeout: 3000
	},
	states: [],
	cities: [],
	micro_markets: [],
	allLangData: [],
	pageTitle: null,
	headerLogo: null,
	salaryStructureSorting: {
		col: -1,
		desc: false
	}
};

export const initialState = Object.assign({}, state);

const actions = {
	[SHOW_ALERT.action]: ({ commit }, payload) => {
		commit(showAlert, payload);
		setTimeout(() => {
			commit(showAlert, { text: "" });
		}, 3000);
	},
	[UPDATE_PAGE_TITLE.action]: ({ commit }, payload) => {
		const { routeName = "", name = "" } = payload;
		if (name) {
			commit(setPageTitle, name);
		} else {
			const el = PANEL_DATA.find(el => el.routeName === routeName);
			commit(setPageTitle, el.name);
		}
	},
	[SET_PAGE_HEADER_LOGO.action]: ({ commit }, payload) => {
		commit(setPageHeaderLogo, payload);
	},
	[FETCH_REGIONS.action]: ({ commit }, { dataKey, ...payload }) => {
		let endpoint = BASE_URL + "/retailer/v1.0.0/getRegions";
		let requestPayload = {
			params: {
				...payload
			}
		};
		return ApiService.post(endpoint, requestPayload)
			.then(data => {
				let errMsg = DEFAULT_ERROR_MESSAGE;
				if (data.statusCode === 200 && data.response) {
					commit(fetchRegionsSuccess, {
						dataKey,
						data: data.response
					});
					return data;
				} else if (data.errMsg) {
					errMsg = data.errMsg;
				}
				throw new Error(errMsg);
			})
			.catch(err => {
				console.error(err);
				const errMsg = err.message || DEFAULT_ERROR_MESSAGE;
				commit(showAlert, { text: errMsg });
			});
	},
	[FETCH_ALL_LANGUAGES.action]: ({ commit, dispatch }) => {
		let endpoint = BASE_URL + "/tool4";
		let requestPayload = {
			action: "getAllExistingLang"
		};
		return ApiService.post(endpoint, requestPayload)
			.then(data => {
				// console.log(data);
				let errMsg = DEFAULT_ERROR_MESSAGE;
				if (data.statusCode === 200 && Array.isArray(data.response)) {
					commit(fetchAllLangSuccess, data.response);
					return;
				} else if (data.errMsg) {
					errMsg = data.errMsg;
				}
				throw new Error(errMsg);
			})
			.catch(err => {
				console.error(err);
				const errMsg = err.message || DEFAULT_ERROR_MESSAGE;
				dispatch(SHOW_ALERT.dispatch, { text: errMsg }, { root: true });
				throw new Error(errMsg);
			});
	},
	[CHANGE_SALARY_STRUCTURE_SORTING.action]: ({ commit }, payload) => {
		commit(changeSalaryStructureSorting, payload);
	},
	[GET_RETAILER_PROFILE.action]: ({ commit, rootState }, payload) => {
		console.log("rootState: ", rootState);
		let endpoint = BASE_URL + "/jeet11-retail/v1.0.0/getRetailerProfile";
		let requestPayload = {
			access_token: rootState.auth.ACCESS_TOKEN,
			params: {
				...payload
			}
		};
		return ApiService.post(endpoint, requestPayload)
			.then(data => {
				let errMsg = DEFAULT_ERROR_MESSAGE;
				if (data.statusCode === 200 && data.response) {
					return data.response;
				} else if (data.errMsg) {
					errMsg = data.errMsg;
				}
				throw new Error(errMsg);
			})
			.catch(err => {
				console.error(err);
				const errMsg = err.message || DEFAULT_ERROR_MESSAGE;
				commit(showAlert, { text: errMsg });
			});
	},
	[UPDATE_RETAILER_PROFILE.action]: (
		{ commit, rootState },
		{ isCreateCall, ...payload }
	) => {
		const createEndPoint = "/jeet11-retail/v1.0.0/createRetailerProfile";
		const updateEndPoint = "/jeet11-retail/v1.0.0/updateRetailerProfile";
		let endpoint =
			BASE_URL + (isCreateCall ? createEndPoint : updateEndPoint);

		let requestPayload = {
			access_token: rootState.auth.ACCESS_TOKEN,
			params: {
				...payload
			}
		};
		return ApiService.post(endpoint, requestPayload)
			.then(data => {
				console.log("data: ", data);
				let errMsg = DEFAULT_ERROR_MESSAGE;
				if (data.status === "success" && data.response) {
					return data.response;
				} else if (data.errMsg) {
					errMsg = data.errMsg;
				}
				throw new Error(errMsg);
			})
			.catch(err => {
				console.error(err);
				const errMsg = err.message || DEFAULT_ERROR_MESSAGE;
				commit(showAlert, { text: errMsg });
			});
	},
	[GET_DSTR_SIGNATURE.action]: ({ commit, rootState }) => {
		console.log("rootState: ", rootState);
		let endpoint = BASE_URL + "/jeet11-retail/v1.0.0/dstrSignature";
		let requestPayload = {
			access_token: rootState.auth.ACCESS_TOKEN,
			params: {}
		};
		return ApiService.post(endpoint, requestPayload)
			.then(data => {
				let errMsg = DEFAULT_ERROR_MESSAGE;
				if (data.statusCode === 200 && data.response) {
					return data.response;
				} else if (data.errMsg) {
					errMsg = data.errMsg;
				}
				throw new Error(errMsg);
			})
			.catch(err => {
				console.error(err);
				const errMsg = err.message || DEFAULT_ERROR_MESSAGE;
				commit(showAlert, { text: errMsg });
			});
	},
	[UPLOAD_DSTR_SIGNATURE.action]: ({ commit, rootState }, payload) => {
		console.log("rootState: ", rootState);
		let endpoint = BASE_URL + "/jeet11-retail/v1.0.0/uploadSignature";
		let requestPayload = {
			access_token: rootState.auth.ACCESS_TOKEN,
			params: {
				...payload
			}
		};
		return ApiService.post(endpoint, requestPayload)
			.then(data => {
				let errMsg = DEFAULT_ERROR_MESSAGE;
				if (data.statusCode === 200 && data.response) {
					return data.response;
				} else if (data.errMsg) {
					errMsg = data.errMsg;
				}
				throw new Error(errMsg);
			})
			.catch(err => {
				console.error(err);
				const errMsg = err.message || DEFAULT_ERROR_MESSAGE;
				commit(showAlert, { text: errMsg });
			});
	},
	[RESET_COMMON_MODULE.action]: ({ commit }) => {
		commit(resetCommonModule);
	}
};

const mutations = {
	[showAlert](state, payload) {
		if (payload.text) {
			state.alert.show = true;
			state.alert.text = payload.text;
		} else {
			state.alert.show = false;
			state.alert.text = "";
		}
	},
	[setPageTitle](state, payload) {
		state.pageTitle = payload;
	},
	[setPageHeaderLogo](state, payload) {
		state.headerLogo = payload;
	},
	[fetchRegionsSuccess](state, { dataKey, data }) {
		state[dataKey] = data;
	},
	[fetchAllLangSuccess](state, payload) {
		state.allLangData = payload;
	},
	[changeSalaryStructureSorting](state, payload) {
		state.salaryStructureSorting = payload;
	},
	[resetCommonModule](state) {
		Object.keys(initialState).map(key => {
			state[key] = initialState[key];
		});
	}
};

export default {
	namespaced: true,
	state,
	actions,
	mutations
};
